// extracted by mini-css-extract-plugin
export default {"MarketplaceContainer":"index_MarketplaceContainer__36Uh3 typography_bodyFont__3RHTp"};